import { Button, Card, Form } from "antd";
import { DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import ScheduleItem from "./ScheduleItem";
import { useFormContext } from '../../../Context';
import moment from 'moment';

const DisableCronButton = ({ cronUid }) => {
  const { cronMap, updateCronMap } = useFormContext();

  const disableEnableCron = async (cronUid) => {
    const relevantCron = cronMap[cronUid];
    relevantCron.disabled = !relevantCron.disabled;
    updateCronMap(cronUid, relevantCron);
  }

  return (
    <span
      style={{ color: cronMap[cronUid]?.disabled ? '#58bd91' : 'red', cursor: 'pointer' }}
      onClick={() => disableEnableCron(cronUid)}
    >
      { cronMap[cronUid]?.disabled ? 'Enable' : 'Disable' }
    </span>
  )
}

export default function ({ form }) {
  const { cronMap } = useFormContext();
  const cronUid = (fieldName) => form.getFieldValue(['crons', fieldName, 'uid'])

  const renderExtra = (field, remove) => {
    if (cronUid(field.name)) {
      return <DisableCronButton cronUid={cronUid(field.name)} />
    } else {
      return (
        <DeleteOutlined
          onClick={() => remove(field.name)}
          style={{ color: 'red' }}
        />
      )
    }
  }

  const getCronProps = (field) => cronMap[cronUid(field.name)]

  return (
    <Form.List name="crons">
      {(fields, { add, remove }) => (
        <>
          {fields.map((field) => (
            <Card
              key={field.key}
              extra={renderExtra(field, remove)}
              style={{ marginBottom: "20px" }}
            >
              <ScheduleItem
                form={form}
                field={field}
                { ...getCronProps(field) }
              />
            </Card>
          ))}
          <Form.Item>
            <Button
              block
              type="dashed"
              onClick={() => add({ runOnce: true, firstRun: moment() })}
              icon={<PlusOutlined />}
            >
              Add Cron
            </Button>
          </Form.Item>
        </>
      )}
    </Form.List>
  );
}
